import { TransferListOption } from './TransferList';

export const shouldHideCheckbox = (search: string, label: string) =>
  !label.toLocaleLowerCase().includes(search?.toLocaleLowerCase());

export const getNewChecked = <VALUE extends string>(checked: VALUE[], value: VALUE): VALUE[] => {
  const currentIndex = checked.indexOf(value);

  const newChecked = [...checked];

  if (currentIndex === -1) {
    newChecked.push(value);
  } else {
    newChecked.splice(currentIndex, 1);
  }
  return newChecked;
};

export const getLeftOptions = <VALUE extends string>(options: TransferListOption<VALUE>[], values: VALUE[]) =>
  options.filter((option) => !values.includes(option.value));

export const getRightOptions = <VALUE extends string>(options: TransferListOption<VALUE>[], values: VALUE[]) =>
  options.filter((option) => values.includes(option.value));

export const getNewOptions = getLeftOptions;
